import script from "./HelpView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpView.vue?vue&type=script&setup=true&lang=ts"

import "./HelpView.vue?vue&type=style&index=0&id=5d6956dc&lang=scss"

const __exports__ = script;

export default __exports__